import styled from 'styled-components';

export const ResponsiveGridLayoutContainer = styled.div`
    padding: 30px;
`;
